import ViewExtension from "../ViewExtension"

export default ViewExtension.extend({
})
